import { useGetFollowupOutcomeQuery } from '@/services/api/generated/treatmentRecordRequestsService';

interface UseMRFollowupOutcomeParams {
  matterId: string;
  providerId: string;
  requestId: string;
}

export function useMRFollowupOutcome({
  matterId,
  providerId,
  requestId,
}: UseMRFollowupOutcomeParams) {
  const { data, isLoading, error, refetch, isSuccess, isError } =
    useGetFollowupOutcomeQuery(
      { matterId, providerId, requestId },
      { skip: !matterId || !providerId || !requestId },
    );

  // Handle 204 No Content - RTK Query returns undefined for empty responses
  // isSuccess will be true, but data will be undefined
  const hasOutcome = isSuccess && data !== undefined && data !== null;

  return {
    outcome: data ?? null,
    isLoading,
    error,
    refetch,
    hasOutcome,
    isError,
    // Explicit states for UI rendering
    noCallsYet: isSuccess && !hasOutcome, // 204 case - no Voice AI calls made
  };
}
